window.__oryCartInit = function(){
  /* on demonte l'instance precedente (rechargement de section dans l'editeur) */
  if(window.__oryCartTeardown){ try{ window.__oryCartTeardown(); }catch(e){} }

  var S   = window.ORY_CART || {};
  var LEN = Math.max(1, (S.timerMinutes || 10)) * 60000;
  /* la cle depend de la duree : changer la duree reprend effet immediatement */
  var KEY = 'ory_cart_timer_deadline_' + LEN;
  var SIG = JSON.stringify([S.timer, S.timerText, S.timerMinutes, S.ship, S.shipLeft,
                            S.shipDone, S.threshold, S.promo, S.promoImg, S.promoLink,
                            S.promoTitle, S.promoText, S.promoPos]);

  var tick = null, debounce = null, mo = null, memDeadline = 0;
  var cartTotal = typeof S.cartTotal === 'number' ? S.cartTotal : 0;

  /* ---------- en-tete transparent : bascule au seuil de scroll ----------
     Traitement SYNCHRONE dans l'ecouteur : lire window.scrollY et basculer une
     classe est negligeable, et surtout ca ne depend pas de requestAnimationFrame
     (qui est suspendu quand l'onglet passe en arriere-plan : le garde anti-doublon
     restait alors bloque et l'en-tete ne basculait plus jamais). */
  var HDR_TH = typeof S.hdrScroll === 'number' ? S.hdrScroll : 150;
  var hdrEl = null;
  function hdrApply(){
    if(!hdrEl || !hdrEl.isConnected) hdrEl = document.getElementById('x-header-container');
    if(!hdrEl || !hdrEl.classList.contains('transparent-header')) return;
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    var on = y > HDR_TH;
    if(on !== hdrEl.classList.contains('ory-scrolled')) hdrEl.classList.toggle('ory-scrolled', on);
  }

  /* ---------- montant formate au format de la boutique ---------- */
  function money(cents){
    function n(v, dec, th, sep){
      if(isNaN(v) || v == null) v = 0;
      var x = (v / 100).toFixed(dec).split('.');
      var head = x[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return head + (x[1] ? sep + x[1] : '');
    }
    var f = String(S.moneyFormat || '');
    if(!f) return n(cents, 2, ',', '.');
    var re = /\{\{\s*(\w+)\s*\}\}/, m = f.match(re);
    if(!m) return f;
    var out;
    switch(m[1]){
      case 'amount_no_decimals':                      out = n(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator':             out = n(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = n(cents, 0, '.', ','); break;
      case 'amount_with_space_separator':             out = n(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = n(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator':        out = n(cents, 2, "'", '.'); break;
      default:                                        out = n(cents, 2, ',', '.');
    }
    return f.replace(re, out);
  }

  /* ---------- horloge (sessionStorage + repli memoire) ---------- */
  function readDeadline(){
    var raw = 0;
    try { raw = parseInt(sessionStorage.getItem(KEY) || '0', 10) || 0; } catch(e){ raw = 0; }
    if(!raw) raw = memDeadline;
    var now = Date.now();
    if(!raw || raw <= now || raw - now > LEN + 5000){
      raw = now + LEN;
      try { sessionStorage.setItem(KEY, String(raw)); } catch(e){}
    }
    memDeadline = raw;
    return raw;
  }
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function clock(){
    var left = readDeadline() - Date.now();
    if(left < 0) left = 0;
    var sec = Math.floor(left / 1000);
    return pad(Math.floor(sec / 60)) + ':' + pad(sec % 60);
  }

  /* ---------- fabrication des blocs ---------- */
  function el(tag, cls){ var e = document.createElement(tag); if(cls) e.className = cls; return e; }

  function buildTimer(){
    var d = el('div', 'ory-timer');
    d.setAttribute('aria-hidden', 'true');   /* sinon annonce vocale chaque seconde */
    var parts = String(S.timerText || '').split('[[timer]]');
    d.appendChild(document.createTextNode(parts[0] || ''));
    var v = el('span', 'ory-timer__val');
    v.textContent = clock();
    d.appendChild(v);
    if(parts.length > 1) d.appendChild(document.createTextNode(parts[1] || ''));
    return d;
  }

  function buildShip(){
    var w = el('div', 'ory-ship');
    w.appendChild(el('div', 'ory-ship__txt'));
    var bar = el('div', 'ory-ship__bar');
    bar.appendChild(el('span', 'ory-ship__fill'));
    w.appendChild(bar);
    return w;
  }

  function buildPromo(){
    var hasImg  = !!S.promoImg;
    var hasText = !!(S.promoTitle || S.promoText);
    if(!hasImg && !hasText) return null;          /* rien de rempli -> rien affiche */

    var a = el(S.promoLink ? 'a' : 'div', 'ory-promo');
    if(S.promoLink) a.setAttribute('href', S.promoLink);
    if(hasImg) a.style.backgroundImage = "url('" + S.promoImg + "')";

    if(hasImg) a.appendChild(el('span', 'ory-promo__veil'));   /* sans image, la couleur de fond doit rester fidele */
    var inner = el('span', 'ory-promo__in');
    if(S.promoTitle){
      var t = el('span', 'ory-promo__title');
      t.textContent = S.promoTitle;
      inner.appendChild(t);
    }
    if(S.promoText){
      var p = el('span', 'ory-promo__txt');
      p.innerHTML = S.promoText;                  /* richtext du customizer */
      inner.appendChild(p);
    }
    a.appendChild(inner);
    return a;
  }

  /* ---------- mise a jour des valeurs dynamiques ---------- */
  function paintTimer(){
    var els = document.querySelectorAll('#CartDrawer .ory-timer__val');
    if(!els.length) return;
    var t = clock();
    for(var i = 0; i < els.length; i++){
      if(els[i].textContent !== t) els[i].textContent = t;
    }
  }

  function paintShip(){
    var wraps = document.querySelectorAll('#CartDrawer .ory-ship');
    if(!wraps.length) return;
    var th = S.threshold || 0;
    var reached = th <= 0 || cartTotal >= th;
    var pct = th > 0 ? Math.min(100, Math.max(0, (cartTotal / th) * 100)) : 100;
    var msg = reached
      ? String(S.shipDone || '')
      : String(S.shipLeft || '').replace(/\[\[amount\]\]/g, money(th - cartTotal));

    for(var i = 0; i < wraps.length; i++){
      var txt  = wraps[i].querySelector('.ory-ship__txt');
      var fill = wraps[i].querySelector('.ory-ship__fill');
      if(txt && txt.innerHTML !== msg) txt.innerHTML = msg;
      if(fill) fill.style.width = pct + '%';
    }
  }

  function paint(){ paintTimer(); paintShip(); }

  /* ---------- placement dans le tiroir ---------- */
  function dropAll(list){
    for(var i = 0; i < list.length; i++){
      if(list[i].parentNode) list[i].parentNode.removeChild(list[i]);
    }
  }

  function mount(drawer){
    var form = drawer.querySelector('#CartDrawer-Form');
    var itemsWrap = form && form.parentNode;

    /* panier vide -> on retire tout ce qu'on avait injecte */
    if(!itemsWrap || !itemsWrap.parentNode){
      dropAll(drawer.querySelectorAll('.ory-top'));
      dropAll(drawer.querySelectorAll('.ory-bottom'));
      return;
    }
    var host = itemsWrap.parentNode;

    /* --- conteneur du haut (timer + livraison + promo si position=haut) --- */
    var shipOn  = S.ship && S.threshold > 0;   /* seuil vide/0 -> pas de barre */
    var wantTop = S.timer || shipOn || (S.promo && S.promoPos === 'top');
    var tops = drawer.querySelectorAll('.ory-top');
    var top  = null;
    for(var i = 0; i < tops.length; i++){
      if(!top && tops[i].parentNode === host && tops[i].getAttribute('data-sig') === SIG) top = tops[i];
      else if(tops[i].parentNode) tops[i].parentNode.removeChild(tops[i]);
    }
    if(!wantTop){ if(top && top.parentNode) top.parentNode.removeChild(top); }
    else if(!top){
      top = el('div', 'ory-top');
      top.setAttribute('data-sig', SIG);
      if(S.timer) top.appendChild(buildTimer());
      if(shipOn)  top.appendChild(buildShip());
      if(S.promo && S.promoPos === 'top'){ var p = buildPromo(); if(p) top.appendChild(p); }
      /* rien a montrer (ex: promo cochee mais vide) -> on n'insere pas de div vide */
      if(top.childNodes.length) host.insertBefore(top, itemsWrap);
      else top = null;
    } else if(top.nextElementSibling !== itemsWrap){
      host.insertBefore(top, itemsWrap);
    }

    /* --- conteneur du bas (promo si position=bas) --- */
    var wantBot = S.promo && S.promoPos === 'bottom';
    var bots = drawer.querySelectorAll('.ory-bottom');
    var bot  = null;
    for(var j = 0; j < bots.length; j++){
      if(!bot && bots[j].parentNode === host && bots[j].getAttribute('data-sig') === SIG) bot = bots[j];
      else if(bots[j].parentNode) bots[j].parentNode.removeChild(bots[j]);
    }
    if(!wantBot){ if(bot && bot.parentNode) bot.parentNode.removeChild(bot); }
    else if(!bot){
      var pb = buildPromo();
      if(pb){
        bot = el('div', 'ory-bottom');
        bot.setAttribute('data-sig', SIG);
        bot.appendChild(pb);
        if(itemsWrap.nextSibling) host.insertBefore(bot, itemsWrap.nextSibling);
        else host.appendChild(bot);
      }
    }
  }

  /* ---------- remplacement des textes natifs (avec memoire pour le teardown) ---------- */
  var origHeading = null, origBtn = null;
  function relabel(drawer){
    if(S.heading){
      var h = drawer.querySelector('.x-cart-heading p.h3');
      if(h && h.textContent !== S.heading){
        if(origHeading === null) origHeading = h.textContent;
        h.textContent = S.heading;
      }
    }
    if(S.checkoutLabel){
      var b = drawer.querySelector('#checkout-submit .button-text');
      if(b && b.textContent !== S.checkoutLabel){
        if(origBtn === null) origBtn = b.textContent;
        b.textContent = S.checkoutLabel;
      }
    }
  }
  function restoreLabels(){
    var d = document.getElementById('CartDrawer');
    if(!d) return;
    if(origHeading !== null){
      var h = d.querySelector('.x-cart-heading p.h3');
      if(h) h.textContent = origHeading;
    }
    if(origBtn !== null){
      var b = d.querySelector('#checkout-submit .button-text');
      if(b) b.textContent = origBtn;
    }
  }

  /* ---------- reperes CSS (repli si :has non supporte) ---------- */
  function mark(drawer){
    var btn = drawer.querySelector('#checkout-submit');
    if(btn && btn.parentNode && btn.parentNode.parentNode){
      var w = btn.parentNode.parentNode;
      if(w.classList && !w.classList.contains('ory-checkout-wrap')) w.classList.add('ory-checkout-wrap');
    }
    var form = drawer.querySelector('#CartDrawer-Form');
    if(form && form.parentNode && form.parentNode.classList &&
       !form.parentNode.classList.contains('ory-items-wrap')){
      form.parentNode.classList.add('ory-items-wrap');
    }
  }

  function sync(){
    var drawer = document.getElementById('CartDrawer');
    if(!drawer) return;
    mount(drawer);
    relabel(drawer);
    mark(drawer);
    paint();
  }

  /* ---------- total du panier (pour la barre de livraison) ---------- */
  var fetching = false;
  function refreshTotal(){
    if(fetching || !S.ship || !window.fetch) return;
    fetching = true;
    fetch((S.cartUrl || '/cart') + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(c){
        if(c && typeof c.total_price === 'number' && c.total_price !== cartTotal){
          cartTotal = c.total_price;
          paintShip();
        }
      })
      .catch(function(){})
      .then(function(){ fetching = false; });
  }

  function schedule(){
    clearTimeout(debounce);
    debounce = setTimeout(function(){ sync(); refreshTotal(); }, 60);
  }

  function start(){
    sync();
    if(tick) clearInterval(tick);
    tick = setInterval(paintTimer, 1000);

    if(S.hdrFix){
      hdrApply();
      window.addEventListener('scroll', hdrApply, { passive: true });
      window.addEventListener('resize', hdrApply, { passive: true });
    }

    /* Eurus injecte le tiroir en AJAX : on ne connait pas de conteneur stable,
       on observe donc le document MAIS on ne fait le travail que si la mutation
       concerne reellement le panier (sinon chaque animation de la page declencherait
       un remontage + un appel reseau). */
    mo = new MutationObserver(function(muts){
      var touched = false;
      for(var i = 0; i < muts.length && !touched; i++){
        var m = muts[i], t = m.target;
        /* nos propres blocs : on ignore, sinon on boucle */
        if(t && t.nodeType === 1 && t.closest &&
           (t.closest('.ory-top') || t.closest('.ory-bottom'))) continue;
        /* mutation a l'interieur du tiroir ? */
        if(t && t.nodeType === 1 && t.closest && t.closest('#CartDrawer')){ touched = true; break; }
        /* le tiroir vient-il d'etre (re)injecte ? */
        for(var k = 0; k < m.addedNodes.length; k++){
          var n = m.addedNodes[k];
          if(n.nodeType === 1 && (n.id === 'CartDrawer' ||
             (n.querySelector && n.querySelector('#CartDrawer')))){ touched = true; break; }
        }
      }
      if(!touched) return;
      /* remontage immediat : pas de saut de mise en page apres un re-rendu AJAX */
      var drawer = document.getElementById('CartDrawer');
      if(drawer){ mount(drawer); relabel(drawer); paint(); }
      refreshTotal();   /* le total doit repartir tout de suite, pas dans 60 ms */
      schedule();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    /* le seul evenement panier reellement emis par Eurus */
    document.addEventListener('eurus:cart:items-changed', schedule);

    window.__oryCartTeardown = function(){
      clearInterval(tick);
      clearTimeout(debounce);
      if(mo) mo.disconnect();
      window.removeEventListener('scroll', hdrApply);
      window.removeEventListener('resize', hdrApply);
      var hc = document.getElementById('x-header-container');
      if(hc) hc.classList.remove('ory-scrolled');
      document.removeEventListener('eurus:cart:items-changed', schedule);
      restoreLabels();
      dropAll(document.querySelectorAll('.ory-top'));
      dropAll(document.querySelectorAll('.ory-bottom'));
      window.__oryCartTeardown = null;
    };
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
};
